export const footerLinksConfig = {
  // Values must match STUDIO_SECTION_REFS in pages/landingStudio/content.js.
  '/studio': [
    { key: 1, name: 'Top', link: '#home-section-0' },
    { key: 2, name: "What's Inside", link: '#home-section-1' },
    { key: 3, name: 'Rep Lab', link: '#home-section-2' },
    { key: 4, name: 'Schedule', link: '#home-section-3' },
    { key: 5, name: 'About', link: '#home-section-4' },
    { key: 6, name: 'Pricing', link: '#home-section-5' },
    { key: 7, name: 'FAQ', link: '#home-section-6' },
  ],
  '/online': [
    { key: 1, name: 'Top', link: '#home-section-0' },
    { key: 2, name: 'Problem', link: '#home-section-1' },
    { key: 3, name: 'Who This Is For', link: '#home-section-2' },
    { key: 4, name: 'Platform', link: '#home-section-3' },
    { key: 5, name: 'Pricing', link: '#home-section-4' },
    { key: 6, name: 'Why 3 Months', link: '#home-section-5' },
    { key: 7, name: 'How It Works', link: '#home-section-6' },
    { key: 8, name: 'About', link: '#home-section-7' },
    { key: 9, name: 'Reviews', link: '#home-section-8' },
    { key: 10, name: 'FAQ', link: '#home-section-9' },
  ],
  '/': [
    { key: 1, name: 'Top', link: '#home-section-0' },
    { key: 2, name: 'Training Options', link: '#home-section-1' },
    { key: 3, name: 'Contact', link: '#home-section-2' },
  ],
  '/onsite': [
    { key: 1, name: 'Top', link: '#home-section-0' },
    { key: 2, name: 'Featured', link: '#home-section-1' },
    { key: 3, name: 'Results', link: '#home-section-2' },
    { key: 4, name: 'About', link: '#home-section-3' },
    { key: 5, name: 'The System', link: '#home-section-4' },
    { key: 6, name: 'How It Works', link: '#home-section-5' },
    { key: 7, name: 'Program', link: '#home-section-6' },
    { key: 8, name: 'Reviews', link: '#home-section-7' },
    { key: 9, name: 'Guarantee', link: '#home-section-8' },
    { key: 10, name: 'Contact', link: '#home-section-9' },
  ],
};
